import React from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {Link} from "react-router-dom"
import {getPathBack} from "../functions"

export class SortWindowClass extends React.Component {

    render() {

        const {show, closeHandler, sortHandler, sortName, order} = this.props

        return (
            <>
                <Modal id={"sort-modal"} show={show}>
                    <Modal.Header>
                        <Modal.Title className={'w-100 text-center'}>{'Сортировать папку'}</Modal.Title>
                        <div className={'d-flex align-items-start'}>
                            <Link to={getPathBack()}>
                                <Button className={'ms-2'} variant={"close"} onClick={closeHandler}/>
                            </Link>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{width: '60%', position: 'relative', left: '90px'}}>
                            <div id={'sort'} className={'d-flex'}>
                                <div className={'w-100'}>
                                    {sortName !== 'name' && <div
                                        className={'text-decoration-none text-dark fs-5'}
                                        onClick={() => {sortHandler('name', order)}}
                                        style={{cursor: 'pointer'}}>
                                        <div className={`p-1 m-1 bg-body-secondary rounded-2`}>
                                            {'По имени'}
                                        </div>
                                    </div>}
                                    {sortName === 'name' && <div className={'text-decoration-none text-dark fs-5'} style={{cursor: 'default'}}>
                                        <div className={`p-1 m-1 text-bg-secondary rounded-2`}>
                                            {'По имени'}
                                        </div>
                                    </div>}
                                    {sortName !== 'type' && <div
                                        className={'text-decoration-none text-dark fs-5'}
                                        onClick={() => {sortHandler('type', order)}}
                                        style={{cursor: 'pointer'}}>
                                        <div className={`p-1 m-1 bg-body-secondary rounded-2`}>
                                            {'По типу'}
                                        </div>
                                    </div>}
                                    {sortName === 'type' && <div className={'text-decoration-none text-dark fs-5'}>
                                        <div className={`p-1 m-1 text-bg-secondary rounded-2`} style={{cursor: 'default'}}>
                                            {'По типу'}
                                        </div>
                                    </div>}
                                    {sortName !== 'date' && <div
                                        className={'text-decoration-none text-dark fs-5'}
                                        onClick={() => {sortHandler('date', order)}}
                                        style={{cursor: 'pointer'}}>
                                        <div className={`p-1 m-1 bg-body-secondary rounded-2`}>
                                            {'По дате'}
                                        </div>
                                    </div>}
                                    {sortName === 'date' && <div className={'text-decoration-none text-dark fs-5'}>
                                        <div className={`p-1 m-1 text-bg-secondary rounded-2`} style={{cursor: 'default'}}>
                                            {'По дате'}
                                        </div>
                                    </div>}
                                </div>
                                <div className={'h-auto p-1'}>
                                    {order === 'asc' && <div
                                        className={'btn bg-body-secondary d-grid h-100 align-items-center p-1'}
                                        onClick={() => {sortHandler(sortName, 'desc')}}>
                                        <div className={'text-bg-secondary p-2 rounded-2'}>
                                            <i className={"fa-solid fa-arrow-up-wide-short"}/>
                                        </div>
                                        <div className={'bg-body-secondary p-2 rounded-2'}>
                                            <i className={"fa-solid fa-arrow-down-short-wide"}/>
                                        </div>
                                    </div>}
                                    {order === 'desc' && <div
                                        className={'btn bg-body-secondary d-grid h-100 align-items-center p-1'}
                                        onClick={() => {sortHandler(sortName, 'asc')}}>
                                        <div className={'bg-body-secondary p-2 rounded-2'}>
                                            <i className={"fa-solid fa-arrow-up-wide-short"}/>
                                        </div>
                                        <div className={'text-bg-secondary p-2 rounded-2'}>
                                            <i className={"fa-solid fa-arrow-down-short-wide"}/>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer/>
                </Modal>
            </>
        )
    }
}